import { connect } from "react-redux";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { post_archivo_oferta } from "../../services/documentos";

function SubirArchivoOferta({ oferta, show, close, onUploadSuccess }) {
  const [file, setFile] = useState(false);
  const [descrip, setDescrip] = useState("");

  const cerrar = () => {
    close(false);
  };

  const subirArchivo = async () => {
    const params = {
      descrip,
      oferta_id: oferta.id,
    };
    try {
      await post_archivo_oferta(file, params);
      cerrar();

      // Llamar a la función de éxito para actualizar la lista de archivos
      if (onUploadSuccess) {
        onUploadSuccess();
      }
    } catch (error) {
      console.error("Error al subir el archivo:", error);
    }
  };

  return (
    <Modal
      show={show}
      size="md"
      backdrop="static"
      centered
      contentClassName="border-0 rounded-4 shadow-lg"
    >
      <Modal.Header className="bg-white border-bottom-0" closeButton onHide={cerrar}>
        <div className="d-flex flex-column">
          <Modal.Title className="fw-bold text-primary">Cargar Archivo</Modal.Title>
          <span className="text-muted small">Oferta Nº {oferta.name}</span>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold small text-muted text-uppercase">Tipo de archivo</Form.Label>
            <Form.Select
              className="form-control rounded-3 border-light shadow-sm bg-light"
              value={descrip}
              onChange={e => setDescrip(e.target.value)}
            >
              <option value="">Seleccionar tipo</option>
              <option value="contrato">Contrato</option>
              <option value="contrato_signed">Contrato firmado</option>
              <option value="pre_contrato">PRE-Contrato</option>
              <option value="cif_nif">CIF/NIF</option>
              <option value="boletin">Boletín</option>
              <option value="fact_ant">Factura anterior</option>
              <option value="auto_repr">Autorización Representación</option>
              <option value="otros">Otros</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="fw-bold small text-muted text-uppercase">Documento</Form.Label>
            <Form.Control
              type="file"
              className="rounded-3 border-light shadow-sm bg-light"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0">
        <Button
          variant="outline-secondary"
          className="rounded-pill px-4 fw-bold"
          onClick={cerrar}
        >
          Cancelar
        </Button>
        <Button
          variant="primary"
          disabled={!descrip || !file}
          className="rounded-pill px-4 fw-bold shadow-sm"
          onClick={() => subirArchivo()}
        >
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default connect()(SubirArchivoOferta);
